import { render, staticRenderFns } from "./PartnersNewPartnerHeader.vue?vue&type=template&id=57c178cd&"
import script from "./PartnersNewPartnerHeader.vue?vue&type=script&lang=js&"
export * from "./PartnersNewPartnerHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports